
import { Component, Vue } from 'vue-property-decorator'
import FormsManagement from '@/components/admin/forms-management.vue'
@Component({ components: { FormsManagement } })
export default class FormsManagementView extends Vue {}
